import React from "react";
import { useNavigate } from "react-router-dom";

const InnerThighPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .innerThigh-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #fef2f2 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .innerThigh-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .innerThigh-hero {
          padding: 26px 22px 30px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(244, 114, 182, 0.18), rgba(56, 189, 248, 0.06));
          margin-bottom: 32px;
          display: grid;
          grid-template-columns: minmax(0, 1.4fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .innerThigh-hero {
            grid-template-columns: 1fr;
          }
        }

        .innerThigh-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(244, 114, 182, 0.22);
          color: #9d174d;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .innerThigh-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #f472b6;
        }

        .innerThigh-title {
          font-size: clamp(28px, 4vw, 36px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 8px;
        }

        .innerThigh-subtitle {
          font-size: 15px;
          max-width: 540px;
          color: #374151;
        }

        .innerThigh-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 14px 0 16px;
        }

        .innerThigh-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .innerThigh-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 8px;
        }

        .innerThigh-btnPrimary,
        .innerThigh-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .innerThigh-btnPrimary {
          background: #ec4899;
          color: #f9fafb;
          box-shadow: 0 9px 22px rgba(236, 72, 153, 0.35);
        }

        .innerThigh-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 28px rgba(236, 72, 153, 0.48);
        }

        .innerThigh-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .innerThigh-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .innerThigh-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .innerThigh-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* STRIPES */
        .innerThigh-stripe {
          padding: 30px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.4);
        }

        .innerThigh-sectionTitle {
          font-size: 20px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .innerThigh-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 16px;
        }

        .innerThigh-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .innerThigh-flexCol {
          flex: 1 1 260px;
        }

        .innerThigh-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        .innerThigh-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 7px;
        }

        .innerThigh-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .innerThigh-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          margin-top: 6px;
          background: #ec4899;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .innerThigh-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .innerThigh-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .innerThigh-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .innerThigh-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE */
        .innerThigh-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
        }

        .innerThigh-step {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15, 23, 42, 0.03);
        }

        .innerThigh-stepLabel {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .innerThigh-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* BANNER */
        .innerThigh-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 18px;
        }

        .innerThigh-banner img {
          width: 100%;
          height: 230px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .innerThigh-banner img {
            height: 260px;
          }
        }

        .innerThigh-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.82), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 8px;
        }

        .innerThigh-bannerText {
          color: #fee2e2;
          font-size: 15px;
          max-width: 420px;
        }

        .innerThigh-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
        }

        .innerThigh-bannerButtons button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .innerThigh-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .innerThigh-bannerButtons .secondary {
          background: rgba(255, 255, 255, 0.16);
          color: #f9fafb;
          border: 1px solid rgba(255, 255, 255, 0.6);
        }

        /* BOTTOM STRIP */
        .innerThigh-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .innerThigh-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .innerThigh-bottomText strong {
          color: #fef9c3;
        }

        .innerThigh-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .innerThigh-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .innerThigh-bottomActions .primary {
          background: #ec4899;
          color: #f9fafb;
        }

        .innerThigh-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .innerThigh-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="innerThigh-page">
        <div className="innerThigh-inner">
          {/* HERO */}
          <section className="innerThigh-hero">
            <div>
              <div className="innerThigh-tag">
                <span className="innerThigh-tagDot" />
                Inner Thigh · Adductors
              </div>
              <h1 className="innerThigh-title">
                Calm inner thigh tension so walking, standing, and moving sideways feel more secure.
              </h1>
              <p className="innerThigh-subtitle">
                The adductor muscles along the inner thigh help control side-to-side movement, support your pelvis,
                and assist with walking and sports. When they&apos;re strained or overloaded, you may feel sharp,
                pulling, or tight discomfort.
              </p>

              <div className="innerThigh-chips">
                <span className="innerThigh-chip">Groin pulls</span>
                <span className="innerThigh-chip">Inner thigh tightness</span>
                <span className="innerThigh-chip">Sports-related strains</span>
                <span className="innerThigh-chip">Discomfort with side steps</span>
              </div>

              <div className="innerThigh-ctaRow">
                <button
                  className="innerThigh-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book an inner thigh visit →
                </button>
                <button
                  className="innerThigh-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="innerThigh-heroImgWrap">
              <img
                src="/content/inner-thigh/inner_thigh_hero.png"
                alt="Therapist assessing inner thigh and groin muscles"
                className="innerThigh-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="innerThigh-stripe">
            <div className="innerThigh-sectionTitle">What can go wrong in the inner thigh?</div>
            <p className="innerThigh-sectionSubtitle">
              The adductors don&apos;t just pull your legs together. They also help stabilize your pelvis and
              control small shifts with walking, running, and changing direction.
            </p>

            <div className="innerThigh-flexRow">
              <div className="innerThigh-flexCol">
                <ul className="innerThigh-list">
                  <li>
                    <span className="innerThigh-bullet" />
                    <span>
                      <strong>Adductor strain:</strong> sharp or pulling pain along the inner thigh,
                      often from sports or a sudden slip.
                    </span>
                  </li>
                  <li>
                    <span className="innerThigh-bullet" />
                    <span>
                      <strong>Chronic tightness:</strong> a constant, tight band feeling along the inner thigh,
                      especially with side steps or lunges.
                    </span>
                  </li>
                  <li>
                    <span className="innerThigh-bullet" />
                    <span>
                      <strong>Weakness or fatigue:</strong> feeling like the leg wants to “buckle in” or lacks stability when turning.
                    </span>
                  </li>
                  <li>
                    <span className="innerThigh-bullet" />
                    <span>
                      <strong>Post-injury guarding:</strong> muscles gripping too hard after a previous pull,
                      making it hard to fully relax or trust the leg.
                    </span>
                  </li>
                </ul>

                <div className="innerThigh-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="innerThigh-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if your inner thigh symptoms fit →
                  </button>
                  <button
                    className="innerThigh-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="innerThigh-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/inner-thigh/inner_thigh_adductors.png"
                  alt="Therapist treating inner thigh adductor muscles"
                  className="innerThigh-img"
                />
              </div>
            </div>

            <div className="innerThigh-cardGrid">
              <div className="innerThigh-card">
                <div className="innerThigh-cardTitle">Adductor Longus</div>
                <div className="innerThigh-cardText">
                  A major inner thigh muscle that helps bring the leg inward and stabilize the pelvis.
                </div>
              </div>
              <div className="innerThigh-card">
                <div className="innerThigh-cardTitle">Adductor Magnus</div>
                <div className="innerThigh-cardText">
                  A large, powerful adductor that also helps with extension and stability of the hip.
                </div>
              </div>
              <div className="innerThigh-card">
                <div className="innerThigh-cardTitle">Adductor Brevis</div>
                <div className="innerThigh-cardText">
                  A shorter adductor muscle that fine-tunes hip control and movement.
                </div>
              </div>
              <div className="innerThigh-card">
                <div className="innerThigh-cardTitle">Gracilis</div>
                <div className="innerThigh-cardText">
                  A long, thin muscle running down the inner thigh that assists with hip and knee motion.
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="innerThigh-stripe">
            <div className="innerThigh-flexRow">
              <div className="innerThigh-flexCol">
                <img
                  src="/content/inner-thigh/inner_thigh_gracilis.png"
                  alt="Manual therapy and stretching along the inner thigh"
                  className="innerThigh-img"
                />
              </div>

              <div className="innerThigh-flexCol">
                <div className="innerThigh-sectionTitle">How physical therapy helps the inner thigh</div>
                <p className="innerThigh-sectionSubtitle">
                  We help irritated tissue calm down, restore smooth motion, and then build stability
                  so you can trust your leg again.
                </p>

                <ul className="innerThigh-list">
                  <li>
                    <span className="innerThigh-bullet" />
                    <span>
                      <strong>Soft-tissue techniques:</strong> gentle, targeted work for adductors and nearby muscles
                      to reduce guarding and tightness.
                    </span>
                  </li>
                  <li>
                    <span className="innerThigh-bullet" />
                    <span>
                      <strong>Gradual stretching:</strong> safe, progressive stretches rather than aggressive pulls
                      that can re-irritate the area.
                    </span>
                  </li>
                  <li>
                    <span className="innerThigh-bullet" />
                    <span>
                      <strong>Hip and core stability:</strong> teaching hips and trunk to share the load so the inner thigh
                      isn&apos;t doing everything alone.
                    </span>
                  </li>
                  <li>
                    <span className="innerThigh-bullet" />
                    <span>
                      <strong>Return-to-sport planning:</strong> for those who cut, pivot, or skate, we guide a stepwise
                      return so you&apos;re not guessing.
                    </span>
                  </li>
                </ul>

                <div className="innerThigh-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="innerThigh-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start with one inner thigh session →
                  </button>
                  <button
                    className="innerThigh-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* VISIT FLOW */}
          <section className="innerThigh-stripe">
            <div className="innerThigh-sectionTitle">What an inner thigh session may look like</div>

            <div className="innerThigh-flexRow">
              <div className="innerThigh-flexCol">
                <img
                  src="/content/inner-thigh/inner_thigh_strength.png"
                  alt="Patient doing inner thigh strengthening exercises with guidance"
                  className="innerThigh-img"
                />
              </div>

              <div className="innerThigh-flexCol">
                <div className="innerThigh-timeline">
                  <div className="innerThigh-step">
                    <div className="innerThigh-stepLabel">1. Your story</div>
                    <div className="innerThigh-stepText">
                      How did it start? Was it a specific moment (like a pull) or a slower build-up with activity?
                    </div>
                  </div>
                  <div className="innerThigh-step">
                    <div className="innerThigh-stepLabel">2. Motion & strength check</div>
                    <div className="innerThigh-stepText">
                      We check hip motion, inner thigh strength, and how your leg moves during walking and side steps.
                    </div>
                  </div>
                  <div className="innerThigh-step">
                    <div className="innerThigh-stepLabel">3. Hands-on care</div>
                    <div className="innerThigh-stepText">
                      You try specific manual work and gentle stretches to see what eases stiffness or pulling.
                    </div>
                  </div>
                  <div className="innerThigh-step">
                    <div className="innerThigh-stepLabel">4. Focused exercises</div>
                    <div className="innerThigh-stepText">
                      You get a short list of exercises (not a whole workout) to help you rebuild confidence and control.
                    </div>
                  </div>
                </div>

                <div className="innerThigh-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="innerThigh-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book an inner thigh evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="innerThigh-stripe">
            <div className="innerThigh-banner">
              <img
                src="/content/inner-thigh/inner_thigh_banner.png"
                alt="Bright physical therapy clinic environment"
              />
              <div className="innerThigh-bannerOverlay">
                <div className="innerThigh-bannerText">
                  Inner thigh sessions happen in a calm, one-on-one setting where we match the plan
                  to your comfort level, sport, and daily life.
                </div>
                <div className="innerThigh-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule inner thigh visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="innerThigh-stripe">
            <div className="innerThigh-bottomStrip">
              <div className="innerThigh-bottomText">
                If you notice sudden, severe groin or inner thigh pain with a popping sensation,
                can&apos;t bear weight, see major bruising or swelling, or have symptoms like fever
                or pain that feels deeper than muscle,{" "}
                <strong>seek medical or emergency care first.</strong> Physical therapy can then help
                guide safe recovery once serious causes are ruled out.
              </div>
              <div className="innerThigh-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule inner thigh PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default InnerThighPT;
